import CrudCustom from '../../../libs/custom/CrudCustom';

let TarifPph25Service = new CrudCustom('/tarif-pph-25s');
export default TarifPph25Service;
